const showDimensions = () => {
    if ($('.breakpoint-section').length) {
        const dimensions = `${screen.width} x ${screen.height}`
        const innerDimensions = `${window.innerWidth} x ${window.innerHeight}`

        $('.js-place-width').text(dimensions)
        $('.js-place-width-inner').text(innerDimensions)
    }
}

$(window).on('load resize', () => {
    showDimensions()
})
